module.exports = __webpack_public_path__ + "src/assets/img/okkotheatre.c4c096cd.jpg";